<template>
    <div class="top_line lk">
        <div class="container">
            <nav class="nav_box">
                <ul class="links_box">
                    <router-link tag="li" to="/lk" :class="page === 'userMonitor' ? 'nav_link active':'nav_link'">Онлайн-монитор</router-link>
                    <router-link tag="li" to="/lk/personal" :class="page === 'userPersonal' ? 'nav_link active':'nav_link'">Персональная информация</router-link>
                    <router-link tag="li" to="/lk/restaurants" :class="page === 'userRestaurants' || page === 'userRestaurant' ? 'nav_link active':'nav_link'">Список ресторанов</router-link>
                    <router-link tag="li" to="/lk/stats" :class="page === 'userStats' ? 'nav_link active':'nav_link'">Статистика</router-link>
                    <router-link tag="li" to="/lk/referral" v-if="$root.user.access === 'admin'" :class="page === 'userReferral' ? 'nav_link active':'nav_link'">Реферальная программа</router-link>
                    <router-link tag="li" to="/lk/presents" v-if="$root.user.access === 'admin'" :class="page === 'userPresents' || page === 'userPresent' ? 'nav_link active':'nav_link'">Подарки</router-link>
                    <a :href="'https://lk.when-hungry.com/site/auth?email=' + this.$root.user.email + '&key=' + this.$root.user.password" target="_blank" class="nav_link">Старый Личный Кабинет</a>
                    <!--router-link tag="li" to="#" :class="page === 'userFinance' ? 'nav_link active':'nav_link'">Финансовый результат</router-link>
                    <router-link tag="li" to="#" :class="page === 'userDocs' ? 'nav_link active':'nav_link'">Документы для загрузки</router-link-->
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel'
export default {
  name: 'navigate',
  data () {
    return {
      page: 'index',
      slickTimeout: null
    }
  },
  created () {
    this.page = this.$route.name
  },
  mounted () {
  },
  methods: {
    initSlick () {
      clearInterval(this.slickTimeout)
      $('.nav_box .links_box').slick({
        dots: false,
        arrows: true,
        speed: 300,
        slidesToShow: 6,
        swipeToSlide: true,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 976,
            settings: {
              dots: false,
              speed: 300,
              slidesToShow: 4,
              swipeToSlide: true,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              dots: false,
              speed: 300,
              slidesToShow: 3,
              swipeToSlide: true,
              slidesToScroll: 2
            }
          }
        ]
      })
    }
  },
  watch: {
    $route (to, from) {
      this.page = to.name
    },
    'page' () {
      this.slickTimeout = setInterval(() => {
        if ($('.nav_box .links_box.slick-initialized').length && $('.links_box li').length) {
          this.initSlick()
        } else if ($('.nav_box .links_box li').length && this.$root.user.access) {
          console.log(this.$root.user.access)
          this.initSlick()
        }
      }, 250)
    }
  }
}
</script>

<style scoped>
li.nav_link {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/lk/user/navigate.vue